import React, { useState } from 'react';

function FaqItem({ question, answer }) {
  const [open, setOpen] = useState(false);
  return (
    <div
      className={`faq-accordion-item${open ? ' faq-accordion-item--open' : ''}`}
      onClick={() => setOpen(!open)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setOpen(!open); } }}
    >
      <div className="faq-accordion-header">
        <h4>{question}</h4>
        <span className="faq-accordion-icon">{open ? '\u2212' : '+'}</span>
      </div>
      {open && (
        <div className="faq-accordion-body">
          <p>{answer}</p>
        </div>
      )}
    </div>
  );
}

function FaqAccordion({ items }) {
  return (
    <div className="faq-accordion">
      {items.map((item, i) => (
        <FaqItem key={i} question={item.question} answer={item.answer} />
      ))}
    </div>
  );
}

export default FaqAccordion;
